import { cn } from '@/lib/utils';
import { Inbox } from 'lucide-react';

export const EmptyState = ({ icon, title, description, action, actionLabel, className }) => {
  const IconComponent = icon || Inbox;
  return (
    <div className={cn('flex flex-col items-center justify-center py-12 px-4 text-center', className)}>
      <div className="w-12 h-12 rounded-xl bg-slate-100 flex items-center justify-center mb-4">
        <IconComponent className="w-6 h-6 text-slate-400" />
      </div>
      <h3 className="font-display text-base font-semibold text-slate-900 mb-1">{title || 'Keine Daten'}</h3>
      <p className="text-sm text-slate-500 max-w-sm">
        {description || 'Noch keine Daten vorhanden.'}
      </p>
      {action && actionLabel && (
        <button 
          onClick={action} 
          className="mt-4 btn-lift inline-flex items-center justify-center rounded-lg bg-slate-900 text-white text-sm font-medium h-10 px-4 hover:bg-slate-800"
          data-testid="empty-state-action-button"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
